<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <div style="width: 100%;height: 50px;">
      <!-- 新增根节点按钮 -->
      <el-button class="el-button-columnBtn" @click="addParent">{{ $t('add') }}</el-button>
    </div>
    <!-- 修改,查看表单 -->
    <el-form label-width="130px"
             style="border-left: 1px rgb(234, 233, 233) solid"
             :model="dataForm"
             ref="dataForm"
             :rules="dataRuleAll"
             v-show="showAddOrUpdateForm">
        <el-row>
            <!-- 业务编码 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.code')">
                <el-input class="fl"
                          v-model="dataForm.bussinessTypeCode"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeMessage')"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 业务名称 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.name')"
                           prop="bussinessTypeName">
                <el-input class="fl"
                          v-model="dataForm.bussinessTypeName"
                          :disabled="isbussinessTypeCode"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 上级业务名称 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.nameone')"
                           prop="seniorBusinessTypeName">
                <el-input class="fl"
                          :disabled="true"
                          placeholder=""
                          v-model="dataForm.seniorBusinessTypeName"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 排序 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.sort')"
                           prop="sort">
                <el-input class="fl"
                          placeholder=""
                          :disabled="isbussinessTypeCode"
                          v-model="dataForm.sort"
                          @input="handleSort"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 是否叶子结点 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.leafFlag')"
                           prop="leafFlag">
                 <el-select v-model="dataForm.leafFlag"
                            class="fl"
                            :disabled="isbussinessTypeCodeleaf"
                            @change="leafFlagChange">
                        <el-option v-for="(item,index) in leafFlag"
                                  :key="index"
                                  :label="item.name"
                                  :value="item.code">
                        </el-option>
                  </el-select>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
          <!-- 修改确认按钮 -->
          <el-col :span="6">
            <div class="label-button-save">
              <el-button type="primary" @click="updataSave(data)" v-if="updataSaveButton">{{ $t('user.save') }}</el-button>
            </div>
          </el-col>
           <!-- 取消按钮 -->
          <!-- <el-col :span="6">
            <div class="label-button-cancel">
              <el-button type="" @click="treeCancel" v-if="updataCancel">{{ $t('user.back') }}</el-button>
            </div>
          </el-col> -->
        </el-row>
    </el-form>
    <!-- 新增表单 -->
    <el-form label-width="130px"
             :rules="dataRuleAdd"
             :model="addDataForm"
             ref="addDataForm"
             style="border-left: 1px rgb(234, 233, 233) solid"
             v-show="showRootForm">
        <el-row>
            <!-- 业务编码 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.code')"
                           prop="addBussinessTypeCode">
                <el-input class="fl"
                          v-model="addDataForm.bussinessTypeCode"
                          :disabled="true"
                          :placeholder="$t('organization.orgCodeMessage')"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 业务名称 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.name')"
                          prop="bussinessTypeName">
                <el-input class="fl"
                          v-model="addDataForm.bussinessTypeName"
                          :placeholder="$t('user.inputContent')"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row v-if="isMain">
            <!-- 上级业务名称 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.nameone')"
                           prop="seniorBusinessTypeName">
                <el-input class="fl"
                          :disabled="true"
                          v-model="addDataForm.seniorBusinessTypeName"
                          :placeholder="$t('organization.orgCodeMessage')"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 排序 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.sort')"
                           prop="sort">
                <el-input class="fl"
                          v-model="addDataForm.sort"
                          :placeholder="$t('user.inputContent')"
                          @input="handleAddSort"></el-input>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <!-- 是否叶子结点 -->
            <el-col :span="12"
                    class="mar-b">
            <el-form-item :label="$t('management.leafFlag')"
                           prop="leafFlag">
                <el-select v-model="addDataForm.leafFlag"
                           class="fl"
                           :placeholder="$t('user.select')"
                           @change="leafFlagChange">
                    <el-option v-for="(item,index) in leafFlag"
                              :key="index"
                              :label="item.name"
                              :value="item.code">
                    </el-option>
              </el-select>
            </el-form-item>
            </el-col>
        </el-row>
        <el-row>
         <!-- 新增确认按钮 -->
          <el-col :span="6">
            <div class="label-button-save">
              <el-button type="primary" @click="addSave" v-if="addSaveButton">{{ $t('user.save') }}</el-button>
            </div>
          </el-col>
          <!-- 新增主节点确认按钮 -->
          <el-col :span="6">
            <div class="label-button-save">
              <el-button type="primary" @click="addParentSave" v-if="addParentSaveButton">{{ $t('user.save') }}</el-button>
            </div>
          </el-col>
          <!-- 取消按钮 -->
          <!-- <el-col :span="6">
            <div class="label-button-cancel">
              <el-button type="" @click="cancel">{{ $t('user.back') }}</el-button>
            </div>
          </el-col> -->
        </el-row>
    </el-form>
    <el-tree :data="data"
             :props="defaultProps"
             node-key="bussinessTypeId"
             @node-click="handleNodeClick"
             :default-expanded-keys="idArr"
             @node-expand="expandClick"
             @node-collapse="collapseClick"
             :expand-on-click-node="false">
      <span class="custom-tree-node"
            slot-scope="{ node, data }">
        <span class="tree-label" :title='node.label'>{{ node.label }}</span>
        <span>
            <!-- leafFlag == '10'如果为标签则不显示新增按钮 -->
            <em class="el-icon-plus ipl" @click="add(node, data)"></em>
            <em class="el-icon-edit ipl" @click="update(data)"></em>
            <!-- <em class="el-icon-delete ipl"  @click.stop="isDelete(node, data)"></em> -->
          </span>
      </span>
    </el-tree>
  </el-card>
</template>

<script>
import { treeDataTranslate } from '../../../utils'
import debounce from 'lodash/debounce'
export default {
  data () {
    let _this = this
    return {
      data: [],
      dataForm: {},
      addDataForm: {
        seniorBusinessTypeName: '',
        bussinessTypeName: ''
      },
      idArr: [],
      leafFlag: _this.enums['confirmState'],
      showRootForm: false,
      showAddOrUpdateForm: true,
      addSaveButton: false,
      addParentSaveButton: false,
      updataSaveButton: false,
      updataCancel: false,
      isbussinessTypeCode: true,
      isbussinessTypeCodeleaf: true,
      isbussinessTypeName: true,
      issort: true,
      isMain: false, // 是否显示上级业务名称输入框
      updatelist: '',
      addNode: '',
      alllist: '',
      addchild: '',
      updataSaveList: '',
      checkBussinessTypeId: '',
      treeList: '',
      defaultProps: {
        children: 'children',
        label: 'bussinessTypeName',
        id: 'bussinessTypeId'
      },
      // 阻止冒泡事件
      stopPre: false
    }
  },
  computed: {
    dataRuleAll () {
      return {
        bussinessTypeName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 20, message: this.$t('validate.validateLength', { 'handle': '20' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leafFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    },
    dataRuleAdd () {
      return {
        bussinessTypeName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 20, message: this.$t('validate.validateLength', { 'handle': '20' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        sort: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        leafFlag: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleAddSort () {
      // eslint-disable-next-line no-useless-escape
      this.addDataForm.sort = this.addDataForm.sort.replace(/[^\.\d]/g, '')
      this.addDataForm.sort = this.addDataForm.sort.replace('.', '')
    },
    handleSort () {
      // eslint-disable-next-line no-useless-escape
      this.dataForm.sort = this.dataForm.sort.replace(/[^\.\d]/g, '')
      this.dataForm.sort = this.dataForm.sort.replace('.', '')
    },
    // 展开节点
    expandClick (data, node, templateNode) {
      this.idArr.push(data.bussinessTypeId)
    },
    // 关闭节点
    collapseClick (data, node, templateNode) {
      for (let i = 0; i < this.idArr.length; i++) {
        if (data.bussinessTypeId === this.idArr[i]) {
          this.idArr.splice(i)
        }
      }
    },
    // 查看每个节点详细信息
    handleNodeClick (data, node, templateNode) {
      if (this.stopPre) {
        this.stopPre = false
        return false
      }
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
      this.showAddOrUpdateForm = true
      this.isbussinessTypeCode = true
      this.isbussinessTypeCodeleaf = true
      this.showRootForm = false
      this.updataSaveButton = false
      this.updataCancel = false
      let checkBussinessTypeId = data.bussinessTypeId
      this.$request.get(`/sys/commbussinessdefine/info/${checkBussinessTypeId}`).then((res, total, code, data) => {
        data.result.sort = data.result.sort + ''
        this.dataForm = {
          ...this.dataForm,
          ...data.result
        }
      }).catch(() => { })
    },
    // 新增下级按钮
    add (node, data) {
      this.stopPre = true
      this.$refs.addDataForm.clearValidate()
      this.$refs.dataForm.clearValidate()
      this.isMain = true
      this.addchild = data
      this.addNode = node
      this.idArr.push(data.bussinessTypeId)
      this.addDataForm = {
        bussinessTypeName: '',
        sort: '0'
      }
      this.showRootForm = true
      this.showAddOrUpdateForm = false
      this.addSaveButton = true
      this.addParentSaveButton = false
      this.addDataForm.seniorBusinessTypeName = data.bussinessTypeName
      this.addDataForm.bussinessTypePid = data.bussinessTypeId
    },
    // 新增下级后保存按钮
    addSave: debounce(function (data) {
      this.$refs['addDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post(`/sys/commbussinessdefine/save`,
          this.addDataForm
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.$request.get(`/sys/commbussinessdefine/allList`).then((res, total, code, data) => {
                this.data = treeDataTranslate(data.result, 'bussinessTypeId', 'bussinessTypePid')
              }).catch(() => { })
              this.showRootForm = false
              this.showAddOrUpdateForm = false
              this.addSaveButton = false
            }
          })
        }).catch(() => { })
      })
    }, 1500, { 'leading': true, 'trailing': false }),
    // 修改
    update (data) {
      this.stopPre = true
      if (this.$refs.dataForm) {
        this.$refs.dataForm.clearValidate()
      }
      this.checkBussinessTypeId = data.bussinessTypeId
      this.updatelist = data
      this.$request.get(`/sys/commbussinessdefine/info/${this.checkBussinessTypeId}`).then((res, total, code, data) => {
        data.result.sort = data.result.sort + ''
        this.dataForm = {
          ...this.dataForm,
          ...data.result
        }
      }).catch(() => { })
      if (data.bussinessTypeName === '组织' || data.bussinessTypeNameCn === '组织' || data.bussinessTypeName === '岗位' || data.bussinessTypeNameCn === '岗位') {
        this.isbussinessTypeCodeleaf = true
      } else {
        this.isbussinessTypeCodeleaf = false
      }
      this.showRootForm = false
      this.showAddOrUpdateForm = true
      this.isbussinessTypeCode = false
      this.isbussinessTypeName = false
      this.issort = false
      this.updataSaveButton = true
      this.updataCancel = true
    },
    // 修改后保存
    updataSave: debounce(function (data) {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post(`/sys/commbussinessdefine/update`,
          this.dataForm
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.isbussinessTypeCode = true
              this.isbussinessTypeCodeleaf = true
              this.isbussinessTypeName = true
              this.issort = true
              this.updataSaveButton = false
              this.updataCancel = false
              this.showAddOrUpdateForm = false
              this.updatelist.bussinessTypeCode = this.dataForm.bussinessTypeCode
              this.updatelist.bussinessTypeName = this.dataForm.bussinessTypeName
              this.updatelist.leafFlag = this.dataForm.leafFlag
              if (this.updatelist.sort !== this.dataForm.sort) {
                this.$request.get(`/sys/commbussinessdefine/allList`).then((res, total, code, data) => {
                  this.data = treeDataTranslate(data.result, 'bussinessTypeId', 'bussinessTypePid')
                }).catch(() => { })
              }
              this.dataForm = {}
            }
          })
        }).catch(() => { })
      })
    }, 1500, { 'leading': true, 'trailing': false }),
    // 删除节点
    // isDelete (node, data) {
    //   let alldata = data
    //   console.log(alldata)
    //   let deleteid = data.bussinessTypeId
    //   this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
    //     confirmButtonText: this.$t('confirm'),
    //     cancelButtonText: this.$t('cancel'),
    //     type: 'warning'
    //   }).then(() => {
    //     this.$request.post(`/sys/commbussinessdefine/delete`,
    //       {
    //         'deleteId': deleteid
    //       }
    //     ).then((node, data) => {
    //       this.$message({
    //         message: this.$t('prompt.success'),
    //         type: 'success',
    //         duration: 500
    //       })
    //       // const index = allnode.parent.childNodes.findIndex(d => {
    //       //   return d.data.bussinessTypeId === alldata.bussinessTypeId
    //       // })
    //       // allnode.parent.childNodes.splice(index, 1)
    //       this.$request.get(`/sys/commbussinessdefine/allList`).then((res, total, code, data) => {
    //         this.data = treeDataTranslate(data.result, 'bussinessTypeId', 'bussinessTypePid')
    //       }).catch(() => { })
    //     }).catch(() => { })
    //   }).catch(() => { })
    // },
    leafFlagChange () {
      this.$refs.addDataForm.clearValidate('leafFlag')
      this.$refs.dataForm.clearValidate('leafFlag')
    },
    // 增加根节点按钮
    addParent () {
      this.$refs.addDataForm.clearValidate()
      this.$refs.dataForm.clearValidate()
      this.isMain = false
      this.showRootForm = true
      this.addSaveButton = false
      this.showAddOrUpdateForm = false
      this.addParentSaveButton = true
      this.addDataForm = {
        bussinessTypePid: '0',
        bussinessTypeId: '',
        bussinessTypeCode: '',
        bussinessTypeName: '',
        seniorBusinessTypeName: '',
        sort: '0',
        leafFlag: ''
      }
    },
    // 新增根节点保存
    addParentSave: debounce(function (data) {
      this.$refs['addDataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.post(`/sys/commbussinessdefine/save`,
          this.addDataForm
        ).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.showRootForm = false
              this.showAddOrUpdateForm = false
              this.addParentSaveButton = false
              this.$request.get(`/sys/commbussinessdefine/allList`).then((res, total, code, data) => {
                this.data = treeDataTranslate(data.result, 'bussinessTypeId', 'bussinessTypePid')
              }).catch(() => { })
            }
          })
        }).catch(() => { })
      })
    }, 1500, { 'leading': true, 'trailing': false }),
    // 取消按钮
    cancel () {
      this.showRootForm = false
      this.showAddOrUpdateForm = false
    },
    // 修改取消按钮
    treeCancel () {
      this.showRootForm = false
      this.showAddOrUpdateForm = false
    }
  },
  mounted () {
    // 获取树
    this.$request.get(`/sys/commbussinessdefine/allList`).then((res, total, code, data) => {
      this.treeList = data.result
      this.data = treeDataTranslate(data.result, 'bussinessTypeId', 'bussinessTypePid')
    }).catch(() => { })
  }
}
</script>
<style type="text/css" scoped>
.label-button-save {
  position: relative;
}
.el-tree {
  width: 30%;
  float: left;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  overflow: hidden;
}
.el-tree-node__content>.el-tree-node__expand-icon{
  z-index: 9;
}
.ipl {
  margin-left: 5px;
  padding: 2px;
  border: 1px #ffffff solid;
}
.ipl:hover {
  background-color: #fff;
  color: #1c69d3;
  border: 1px #1c69d3 solid;
}
.el-form {
  width: 70%;
  float: right;
}
.el-form-item {
  text-align: left;
}
.el-input {
  max-width: 300px !important;
}
.el-select {
  max-width: 300px !important;
}
.mar-b {
  margin-bottom: 20px;
}
.tree-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
}
.el-switch {
  float: left;
}
.el-form-item {
  width: 100% !important;
}
</style>
